import { Guid, LicensedAgencyViewModel } from 'api'
import { useNavigate } from 'react-router'
import { DEFAULT_AGENCY_ROUTE } from 'utils/constants'
import {
  useAgencyApi,
  useAuth,
  useAuthApi,
  useCurrentAgency,
  useInvokeApi,
} from '.'

export const useAgency = () => {
  const navigate = useNavigate()
  const { getCurrentSession } = useAuthApi()
  const agencyApi = useAgencyApi()
  const invokeApi = useInvokeApi()
  const { dispatch: dispatchAuthAction } = useAuth()
  const { dispatch: dispatchAgencyAction } = useCurrentAgency(null)

  const getAuthorizedAgencies = async (): Promise<
    LicensedAgencyViewModel[] | null
  > => {
    return await invokeApi(
      () => agencyApi.getAuthorizedAgencies(),
      'An error occurred while loading the authorized agencies.',
      (result) => {
        dispatchAuthAction({
          type: 'AuthorizedAgenciesAction',
          payload: result.map((item) => {
            return { ...item, id: item.licensedAgencyId }
          }),
        })
      },
    )
  }

  const getAgencies = async (): Promise<LicensedAgencyViewModel[] | null> => {
    return await invokeApi(
      () => agencyApi.getAgencies(),
      'An error occurred while loading agencies.',
      (result) => {
        dispatchAuthAction({
          type: 'AgenciesAction',
          payload: result.map((item) => {
            return { ...item, id: item.licensedAgencyId }
          }),
        })
      },
    )
  }

  const assistAgency = async (licensedAgencyId: Guid): Promise<void> => {
    await invokeApi(
      () => agencyApi.assistAgency(licensedAgencyId),
      'There was an error assisting the agency',
      undefined,
      async () => {
        dispatchAgencyAction({
          type: 'Clear',
        })

        await getCurrentSession(dispatchAuthAction)
        navigate(DEFAULT_AGENCY_ROUTE)
      },
    )
  }

  const unassistAgency = async (): Promise<void> => {
    await invokeApi(
      () => agencyApi.unassistAgency(),
      'An error occurred while unassisting agency.',
      undefined,
      () => {
        dispatchAgencyAction({
          type: 'Clear',
        })
      },
    )
  }

  return {
    getAuthorizedAgencies,
    getAgencies,
    assistAgency,
    unassistAgency,
  }
}
